import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import InputCheckbox from '../../../../common/components/ui/InputCheckbox';
import styles from './FieldPriceIncludeVAT.module.scss';

const FieldPriceIncludeVAT = () => {
  const intl = useIntl();
  const labelText = intl.formatMessage({
    id: 'payment-form-priceIncludeVAT',
    defaultMessage: 'VAT included'
  });
  const [field, meta] = useField<boolean>({name: 'priceIncludeVAT'});

  return (
    <InputCheckbox
      {...field}
      {...meta}
      id={field.name}
      checked={field.value}
      label={
        <div>
          <span>{labelText}</span>
        </div>
      }
      customClassNames={{inputContainer: styles.container}}
    />
  );
};

export default FieldPriceIncludeVAT;
